var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center width-100 mt-4",style:({'padding-right': _vm.scrollBar+'px !important'})},[_c('div',{staticClass:"teamName"},[_vm._v(_vm._s(_vm.gamedata.team_a_name))]),_c('div',{staticClass:"placeholder"}),_c('div',{staticClass:"teamName"},[_vm._v(_vm._s(_vm.gamedata.team_b_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }